module.exports = require("/Users/dale/Documents/cp-website/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = ./node_modules/gatsby-plugin-typography/.cache/typography.js
// module chunks = 231608221292675